import { atom } from 'recoil';

export const walletState = atom({
  key: 'walletState',
  default: false,
  effects: [
    ({ setSelf, onSet }) => {
      // 로컬 스토리지에서 값을 복원
      const savedValue = sessionStorage.getItem('login');
      if (savedValue != null) {
        setSelf(savedValue === 'true');
      }

      // 상태가 변경될 때마다 로컬 스토리지에 저장
      onSet((newValue) => {
        sessionStorage.setItem('login', newValue.toString());
      });
    },
  ],
});
